import { Step } from 'react-joyride';

const WorkerProfileTourSteps: Step[] = [
  {
    // ✅ Corregido: era 'h1.tour-title' (selector inválido), ahora '.tour-title'
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a tu <strong>perfil de trabajador</strong>. Desde aquí puedes
        gestionar tu información personal, tu horario, tus servicios y tus
        ausencias.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-foto',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta es tu <strong>foto de perfil</strong>. Pulsa el icono de subida
        para actualizarla cuando quieras. La imagen se recortará automáticamente
        para que quede perfecta.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-info-personal',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí puedes ver tu <strong>nombre, email y teléfono</strong>. Si
        necesitas actualizar algún dato, contacta con el administrador de tu
        empresa.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-btn-horario',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Pulsa aquí para consultar tu <strong>horario laboral</strong> por día de
        la semana. Podrás ver los tramos horarios en los que estás disponible
        para recibir citas.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-btn-servicios',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Desde aquí puedes ver los{' '}
        <strong>servicios que tienes asignados</strong>. Si crees que falta
        alguno o hay un error, contacta con tu responsable.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-nav-año',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Usa las flechas para{' '}
        <strong>navegar entre años y bloques de meses</strong>. Cada bloque
        muestra 4 meses consecutivos para que tengas una visión amplia de tu
        disponibilidad.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-leyenda',
    content: (
      <div style={{ textAlign: 'justify' }}>
        La <strong>leyenda de colores</strong> te ayuda a identificar
        rápidamente cada tipo de día: festivos, no laborables, ausencias
        aprobadas y ausencias pendientes de aprobación.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-resumen-ausencias',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí verás un <strong>resumen rápido</strong> del total de días de
        ausencia del año, cuántos están aprobados y cuántos siguen pendientes de
        revisión.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-calendario',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es tu <strong>calendario anual</strong>. Los días aparecen
        coloreados según su estado. Puedes hacer clic y arrastrar para{' '}
        <strong>seleccionar un rango de días</strong> y solicitar una ausencia
        directamente desde aquí.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-solicitar-ausencia',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Recuerda: para <strong>solicitar una ausencia</strong> solo tienes que
        hacer clic en el día de inicio y arrastrar hasta el día de fin en
        cualquiera de los calendarios. Se abrirá un formulario para completar
        los detalles.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-help-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si en cualquier momento necesitas volver a ver esta guía, pulsa el botón
        de <strong>Ayuda</strong> en la parte superior derecha y el tour se
        iniciará de nuevo.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
];

export default WorkerProfileTourSteps;
